<script lang="ts">
    import type { RouteLocation } from "../routing/route_location";
    import Menubar from "./Menubar.svelte";
    import Questions from "./Questions.svelte";
    import TreeBackground from "./TreeBackground.svelte";

    export let location: RouteLocation;
</script>

<TreeBackground />
<Questions {location} />

<style>
</style>
